type CacheInvalidationCallback = () => void;

class CacheEventEmitter {
  private listeners: Set<CacheInvalidationCallback> = new Set();

  on(callback: CacheInvalidationCallback): void {
    this.listeners.add(callback);
  }

  off(callback: CacheInvalidationCallback): void {
    this.listeners.delete(callback);
  }

  emit(): void {
    this.listeners.forEach(callback => {
      try {
        callback();
      } catch (error) {
        console.error('🔴 [CacheEvents] Error in listener callback:', error);
      }
    });
  }

  getListenerCount(): number {
    return this.listeners.size;
  }
}

const cacheEventEmitter = new CacheEventEmitter();

export const emitCacheInvalidated = (): void => {
  const listenerCount = cacheEventEmitter.getListenerCount();
  console.log(`📡 [CacheEvents] Emitting cache invalidation event to ${listenerCount} listener(s)...`);
  cacheEventEmitter.emit();
};

export const onCacheInvalidated = (callback: CacheInvalidationCallback): void => {
  cacheEventEmitter.on(callback);
};

export const offCacheInvalidated = (callback: CacheInvalidationCallback): void => {
  cacheEventEmitter.off(callback);
};
